import { useState } from 'react';
import { enviarConsulta } from '../utils/inmuebles.service';

export function useEnviarConsulta() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>(null);
  const [success, setSuccess] = useState(false);

  const submit = async (data: any) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      await enviarConsulta(data);
      setSuccess(true);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return { submit, loading, error, success };
}